var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.onClickAuthorizeAirtable}},[_vm._v("Authorize")])}
var staticRenderFns = []
export { render, staticRenderFns }